<template>
    <console-content max-width="1560">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">일일 매출</v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-bind="{ loading }" class="elevation-1 mt-3 mx-1">
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="2" class="py-0">
                            <v-date-field v-model="day" type="date" label="매출일자" persistent-placeholder hide-details @input="search" />
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <v-row>
                                <v-col class="text-h6">당일 총 매출 금액 :</v-col>
                                <v-col class="text-h6 font-weight-bold"> {{ days.total.format() }} 원 </v-col>
                            </v-row>
                        </v-col>
                        <v-spacer />
                        <v-col cols="12" sm="4" class="py-0">
                            <v-row>
                                <v-col class="text-h6">당월 총 매출 금액 :</v-col>
                                <v-col class="text-h6 font-weight-bold">{{ days.monthTotal.format() }} 원</v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">일일 매출 상세</v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-bind="{ loading }" class="elevation-1 mt-3 mx-1">
                <v-card-text>
                    <v-row align="center">
                        <v-col>
                            <v-col class="text-h6" align="center">매출 일자</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ day }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">갤럭시아</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.galaxiaTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">한국문화진흥</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.cultureland2Total.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">페이즈</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.paysTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">다날</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.danalTotal.format() }}</v-col>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col>
                            <v-col class="text-h6" align="center">해피머니</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.happymoneyBulckTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">도서문화상품권</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.paysBulckTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">토핑</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.toppingTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">캐시박스</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.payletterTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">티사이언티픽</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.tscientificTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">바로콘</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ days.baroconTotal.format() }}</v-col>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">월 매출 상세</v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-bind="{ loading }" class="elevation-1 mt-3 mx-1">
                <v-card-text>
                    <v-row align="center">
                        <v-col>
                            <v-col class="text-h6" align="center">월</v-col>
                            <v-divider />
                            <v-col align="center">
                                <v-date-field v-model="month" type="month" persistent-placeholder hide-details @input="search2" />
                            </v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">갤럭시아</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.galaxiaTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">한국문화진흥</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.cultureland2Total.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">페이즈</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.paysTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">다날</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.danalTotal.format() }}</v-col>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col>
                            <v-col class="text-h6" align="center">해피머니</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.happymoneyBulckTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">도서문화상품권</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.paysBulckTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">토핑</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.toppingTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">캐시박스</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.payletterTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">티사이언티픽</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.tscientificTotal.format() }}</v-col>
                        </v-col>
                        <v-col>
                            <v-col class="text-h6" align="center">바로콘</v-col>
                            <v-divider />
                            <v-col class="text-h6 font-weight-bold" align="center">{{ months.baroconTotal.format() }}</v-col>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-expand-transition>
    </console-content>
</template>
<script>
import api from "@/api";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
export default {
    components: {
        VDateField,
        ConsoleContent,
    },
    data() {
        return {
            loading: false,
            day: this.$dayjs().format("YYYY-MM-DD"),
            month: this.$dayjs().format("YYYY-MM"),

            days: {
                total: 0,
                monthTotal: 0,
                galaxiaTotal: 0,
                cultureland2Total: 0,
                paysTotal: 0,
                danalTotal: 0,
                happymoneyBulckTotal: 0,
                paysBulckTotal: 0,
                toppingTotal: 0,
                payletterTotal: 0,
                tscientificTotal: 0,
                baroconTotal: 0,
            },
            months: {
                galaxiaTotal: 0,
                cultureland2Total: 0,
                paysTotal: 0,
                danalTotal: 0,
                happymoneyBulckTotal: 0,
                paysBulckTotal: 0,
                toppingTotal: 0,
                payletterTotal: 0,
                tscientificTotal: 0,
                baroconTotal: 0,
            },
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
            await this.search2();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { days } = await api.console.dashboard.day({
                    params: { day: this.day },
                });
                this.days = days;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
            }
        },

        async search2() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { months } = await api.console.dashboard.month({
                    params: { month: this.month },
                });
                this.months = months;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
            }
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
    },
};
</script>
